import React from 'react';
import { Alert } from 'shards-react';
import { Paragraph } from '@increase/typed-components';

const CantAuthorize = () => (
  <Alert theme="danger">
    <Paragraph>Tu usuario no tiene permisos para ejecutar esta funcionalidad.</Paragraph>
  </Alert>
);

export default CantAuthorize;
